function G(M) {
    return M && M.__esModule && Object.prototype.hasOwnProperty.call(M, "default") ? M.default : M
}
var H = {
    exports: {}
};
/*!
 * 
 *   @nutima.agency/nutima-cart.js v1.0.32
 *   https://github.com/nutimacode/nutima-cart.js
 * 
 *   Copyright (c) nutima (https://www.nutimacode.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */
(function (M, B) {
    (function (C, b) {
        M.exports = b()
    })(window, function () {
        return function (C) {
            var b = {};

            function u(c) {
                if (b[c]) return b[c].exports;
                var l = b[c] = {
                    i: c,
                    l: !1,
                    exports: {}
                };
                return C[c].call(l.exports, l, l.exports, u), l.l = !0, l.exports
            }
            return u.m = C, u.c = b, u.d = function (c, l, L) {
                u.o(c, l) || Object.defineProperty(c, l, {
                    enumerable: !0,
                    get: L
                })
            }, u.r = function (c) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(c, "__esModule", {
                    value: !0
                })
            }, u.t = function (c, l) {
                if (1 & l && (c = u(c)), 8 & l || 4 & l && typeof c == "object" && c && c.__esModule) return c;
                var L = Object.create(null);
                if (u.r(L), Object.defineProperty(L, "default", {
                        enumerable: !0,
                        value: c
                    }), 2 & l && typeof c != "string")
                    for (var v in c) u.d(L, v, function (g) {
                        return c[g]
                    }.bind(null, v));
                return L
            }, u.n = function (c) {
                var l = c && c.__esModule ? function () {
                    return c.default
                } : function () {
                    return c
                };
                return u.d(l, "a", l), l
            }, u.o = function (c, l) {
                return Object.prototype.hasOwnProperty.call(c, l)
            }, u.p = "", u(u.s = 1)
        }([function (C, b, u) {
            var c = u(3),
                l = /^(?:submit|button|image|reset|file)$/i,
                L = /^(?:input|select|textarea|keygen)/i,
                v = /(\[[^\[\]]*\])/g;

            function g(E, y, p) {
                if (y.match(v))(function m(f, _, h) {
                    if (_.length === 0) return f = h;
                    var w = _.shift(),
                        q = w.match(/^\[(.+?)\]$/);
                    if (w === "[]") return f = f || [], Array.isArray(f) ? f.push(m(null, _, h)) : (f._values = f._values || [], f._values.push(m(null, _, h))), f;
                    if (q) {
                        var k = q[1],
                            S = +k;
                        isNaN(S) ? (f = f || {})[k] = m(f[k], _, h) : (f = f || [])[S] = m(f[S], _, h)
                    } else f[w] = m(f[w], _, h);
                    return f
                })(E, function (m) {
                    var f = [],
                        _ = new RegExp(v),
                        h = /^([^\[\]]*)/.exec(m);
                    for (h[1] && f.push(h[1]);
                        (h = _.exec(m)) !== null;) f.push(h[1]);
                    return f
                }(y), p);
                else {
                    var T = E[y];
                    T ? (Array.isArray(T) || (E[y] = [T]), E[y].push(p)) : E[y] = p
                }
                return E
            }

            function x(E, y, p) {
                return p = p.replace(/(\r)?\n/g, `\r
`), p = (p = encodeURIComponent(p)).replace(/%20/g, "+"), E + (E ? "&" : "") + encodeURIComponent(y) + "=" + p
            }
            C.exports = function (E, y) {
                c(y) != "object" ? y = {
                    hash: !!y
                } : y.hash === void 0 && (y.hash = !0);
                for (var p = y.hash ? {} : "", T = y.serializer || (y.hash ? g : x), m = E && E.elements ? E.elements : [], f = Object.create(null), _ = 0; _ < m.length; ++_) {
                    var h = m[_];
                    if ((y.disabled || !h.disabled) && h.name && L.test(h.nodeName) && !l.test(h.type)) {
                        var w = h.name,
                            q = h.value;
                        if (h.type !== "checkbox" && h.type !== "radio" || h.checked || (q = void 0), y.empty) {
                            if (h.type !== "checkbox" || h.checked || (q = ""), h.type === "radio" && (f[h.name] || h.checked ? h.checked && (f[h.name] = !0) : f[h.name] = !1), q == null && h.type == "radio") continue
                        } else if (!q) continue;
                        if (h.type !== "select-multiple") p = T(p, w, q);
                        else {
                            q = [];
                            for (var k = h.options, S = !1, O = 0; O < k.length; ++O) {
                                var j = k[O],
                                    A = y.empty && !j.value,
                                    P = j.value || A;
                                j.selected && P && (S = !0, p = y.hash && w.slice(w.length - 2) !== "[]" ? T(p, w + "[]", j.value) : T(p, w, j.value))
                            }!S && y.empty && (p = T(p, w, ""))
                        }
                    }
                }
                if (y.empty)
                    for (var w in f) f[w] || (p = T(p, w, ""));
                return p
            }
        }, function (C, b, u) {
            C.exports = u(4)
        }, function (C, b, u) {}, function (C, b) {
            function u(c) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? C.exports = u = function (l) {
                    return typeof l
                } : C.exports = u = function (l) {
                    return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l
                }, u(c)
            }
            C.exports = u
        }, function (C, b, u) {
            u.r(b), u(2);
            var c = "${{amount}}";

            function l(t, a) {
                typeof t == "string" && (t = t.replace(".", ""));
                var o = "",
                    d = /\{\{\s*(\w+)\s*\}\}/,
                    e = a || c;

                function r(i) {
                    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2,
                        s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",",
                        D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
                    if (isNaN(i) || i == null) return 0;
                    var F = (i = (i / 100).toFixed(n)).split(".");
                    return F[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(s)) + (F[1] ? D + F[1] : "")
                }
                switch (e.match(d)[1]) {
                    case "amount":
                        o = r(t, 2);
                        break;
                    case "amount_no_decimals":
                        o = r(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        o = r(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        o = r(t, 0, ".", ",")
                }
                return e.replace(d, o)
            }

            function L(t) {
                return (L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (a) {
                    return typeof a
                } : function (a) {
                    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a
                })(t)
            }
            var v = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof v < "u" && v,
                g = {
                    searchParams: "URLSearchParams" in v,
                    iterable: "Symbol" in v && "iterator" in Symbol,
                    blob: "FileReader" in v && "Blob" in v && function () {
                        try {
                            return new Blob, !0
                        } catch {
                            return !1
                        }
                    }(),
                    formData: "FormData" in v,
                    arrayBuffer: "ArrayBuffer" in v
                };
            if (g.arrayBuffer) var x = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
                E = ArrayBuffer.isView || function (t) {
                    return t && x.indexOf(Object.prototype.toString.call(t)) > -1
                };

            function y(t) {
                if (typeof t != "string" && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || t === "") throw new TypeError("Invalid character in header field name");
                return t.toLowerCase()
            }

            function p(t) {
                return typeof t != "string" && (t = String(t)), t
            }

            function T(t) {
                var a = {
                    next: function () {
                        var o = t.shift();
                        return {
                            done: o === void 0,
                            value: o
                        }
                    }
                };
                return g.iterable && (a[Symbol.iterator] = function () {
                    return a
                }), a
            }

            function m(t) {
                this.map = {}, t instanceof m ? t.forEach(function (a, o) {
                    this.append(o, a)
                }, this) : Array.isArray(t) ? t.forEach(function (a) {
                    this.append(a[0], a[1])
                }, this) : t && Object.getOwnPropertyNames(t).forEach(function (a) {
                    this.append(a, t[a])
                }, this)
            }

            function f(t) {
                if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
                t.bodyUsed = !0
            }

            function _(t) {
                return new Promise(function (a, o) {
                    t.onload = function () {
                        a(t.result)
                    }, t.onerror = function () {
                        o(t.error)
                    }
                })
            }

            function h(t) {
                var a = new FileReader,
                    o = _(a);
                return a.readAsArrayBuffer(t), o
            }

            function w(t) {
                if (t.slice) return t.slice(0);
                var a = new Uint8Array(t.byteLength);
                return a.set(new Uint8Array(t)), a.buffer
            }

            function q() {
                return this.bodyUsed = !1, this._initBody = function (t) {
                    var a;
                    this.bodyUsed = this.bodyUsed, this._bodyInit = t, t ? typeof t == "string" ? this._bodyText = t : g.blob && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : g.formData && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : g.searchParams && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : g.arrayBuffer && g.blob && (a = t) && DataView.prototype.isPrototypeOf(a) ? (this._bodyArrayBuffer = w(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : g.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || E(t)) ? this._bodyArrayBuffer = w(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || (typeof t == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : g.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"))
                }, g.blob && (this.blob = function () {
                    var t = f(this);
                    if (t) return t;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                    if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    return Promise.resolve(new Blob([this._bodyText]))
                }, this.arrayBuffer = function () {
                    if (this._bodyArrayBuffer) {
                        var t = f(this);
                        return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer))
                    }
                    return this.blob().then(h)
                }), this.text = function () {
                    var t = f(this);
                    if (t) return t;
                    if (this._bodyBlob) return function (a) {
                        var o = new FileReader,
                            d = _(o);
                        return o.readAsText(a), d
                    }(this._bodyBlob);
                    if (this._bodyArrayBuffer) return Promise.resolve(function (a) {
                        for (var o = new Uint8Array(a), d = new Array(o.length), e = 0; e < o.length; e++) d[e] = String.fromCharCode(o[e]);
                        return d.join("")
                    }(this._bodyArrayBuffer));
                    if (this._bodyFormData) throw new Error("could not read FormData body as text");
                    return Promise.resolve(this._bodyText)
                }, g.formData && (this.formData = function () {
                    return this.text().then(O)
                }), this.json = function () {
                    return this.text().then(JSON.parse)
                }, this
            }
            m.prototype.append = function (t, a) {
                t = y(t), a = p(a);
                var o = this.map[t];
                this.map[t] = o ? o + ", " + a : a
            }, m.prototype.delete = function (t) {
                delete this.map[y(t)]
            }, m.prototype.get = function (t) {
                return t = y(t), this.has(t) ? this.map[t] : null
            }, m.prototype.has = function (t) {
                return this.map.hasOwnProperty(y(t))
            }, m.prototype.set = function (t, a) {
                this.map[y(t)] = p(a)
            }, m.prototype.forEach = function (t, a) {
                for (var o in this.map) this.map.hasOwnProperty(o) && t.call(a, this.map[o], o, this)
            }, m.prototype.keys = function () {
                var t = [];
                return this.forEach(function (a, o) {
                    t.push(o)
                }), T(t)
            }, m.prototype.values = function () {
                var t = [];
                return this.forEach(function (a) {
                    t.push(a)
                }), T(t)
            }, m.prototype.entries = function () {
                var t = [];
                return this.forEach(function (a, o) {
                    t.push([o, a])
                }), T(t)
            }, g.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
            var k = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

            function S(t, a) {
                if (!(this instanceof S)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                var o = (a = a || {}).body;
                if (t instanceof S) {
                    if (t.bodyUsed) throw new TypeError("Already read");
                    this.url = t.url, this.credentials = t.credentials, a.headers || (this.headers = new m(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, o || t._bodyInit == null || (o = t._bodyInit, t.bodyUsed = !0)
                } else this.url = String(t);
                if (this.credentials = a.credentials || this.credentials || "same-origin", !a.headers && this.headers || (this.headers = new m(a.headers)), this.method = function (e) {
                        var r = e.toUpperCase();
                        return k.indexOf(r) > -1 ? r : e
                    }(a.method || this.method || "GET"), this.mode = a.mode || this.mode || null, this.signal = a.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                if (this._initBody(o), (this.method === "GET" || this.method === "HEAD") && (a.cache === "no-store" || a.cache === "no-cache")) {
                    var d = /([?&])_=[^&]*/;
                    d.test(this.url) ? this.url = this.url.replace(d, "$1_=" + new Date().getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime()
                }
            }

            function O(t) {
                var a = new FormData;
                return t.trim().split("&").forEach(function (o) {
                    if (o) {
                        var d = o.split("="),
                            e = d.shift().replace(/\+/g, " "),
                            r = d.join("=").replace(/\+/g, " ");
                        a.append(decodeURIComponent(e), decodeURIComponent(r))
                    }
                }), a
            }

            function j(t) {
                var a = new m;
                return t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (o) {
                    var d = o.split(":"),
                        e = d.shift().trim();
                    if (e) {
                        var r = d.join(":").trim();
                        a.append(e, r)
                    }
                }), a
            }

            function A(t, a) {
                if (!(this instanceof A)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                a || (a = {}), this.type = "default", this.status = a.status === void 0 ? 200 : a.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in a ? a.statusText : "", this.headers = new m(a.headers), this.url = a.url || "", this._initBody(t)
            }
            S.prototype.clone = function () {
                return new S(this, {
                    body: this._bodyInit
                })
            }, q.call(S.prototype), q.call(A.prototype), A.prototype.clone = function () {
                return new A(this._bodyInit, {
                    status: this.status,
                    statusText: this.statusText,
                    headers: new m(this.headers),
                    url: this.url
                })
            }, A.error = function () {
                var t = new A(null, {
                    status: 0,
                    statusText: ""
                });
                return t.type = "error", t
            };
            var P = [301, 302, 303, 307, 308];
            A.redirect = function (t, a) {
                if (P.indexOf(a) === -1) throw new RangeError("Invalid status code");
                return new A(null, {
                    status: a,
                    headers: {
                        location: t
                    }
                })
            };
            var N = v.DOMException;
            try {
                new N
            } catch {
                (N = function (a, o) {
                    this.message = a, this.name = o;
                    var d = Error(a);
                    this.stack = d.stack
                }).prototype = Object.create(Error.prototype), N.prototype.constructor = N
            }

            function I(t, a) {
                return new Promise(function (o, d) {
                    var e = new S(t, a);
                    if (e.signal && e.signal.aborted) return d(new N("Aborted", "AbortError"));
                    var r = new XMLHttpRequest;

                    function i() {
                        r.abort()
                    }
                    r.onload = function () {
                        var n = {
                            status: r.status,
                            statusText: r.statusText,
                            headers: j(r.getAllResponseHeaders() || "")
                        };
                        n.url = "responseURL" in r ? r.responseURL : n.headers.get("X-Request-URL");
                        var s = "response" in r ? r.response : r.responseText;
                        setTimeout(function () {
                            o(new A(s, n))
                        }, 0)
                    }, r.onerror = function () {
                        setTimeout(function () {
                            d(new TypeError("Network request failed"))
                        }, 0)
                    }, r.ontimeout = function () {
                        setTimeout(function () {
                            d(new TypeError("Network request failed"))
                        }, 0)
                    }, r.onabort = function () {
                        setTimeout(function () {
                            d(new N("Aborted", "AbortError"))
                        }, 0)
                    }, r.open(e.method, function (n) {
                        try {
                            return n === "" && v.location.href ? v.location.href : n
                        } catch {
                            return n
                        }
                    }(e.url), !0), e.credentials === "include" ? r.withCredentials = !0 : e.credentials === "omit" && (r.withCredentials = !1), "responseType" in r && (g.blob ? r.responseType = "blob" : g.arrayBuffer && e.headers.get("Content-Type") && e.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (r.responseType = "arraybuffer")), !a || L(a.headers) !== "object" || a.headers instanceof m ? e.headers.forEach(function (n, s) {
                        r.setRequestHeader(s, n)
                    }) : Object.getOwnPropertyNames(a.headers).forEach(function (n) {
                        r.setRequestHeader(n, p(a.headers[n]))
                    }), e.signal && (e.signal.addEventListener("abort", i), r.onreadystatechange = function () {
                        r.readyState === 4 && e.signal.removeEventListener("abort", i)
                    }), r.send(typeof e._bodyInit > "u" ? null : e._bodyInit)
                })
            }
            I.polyfill = !0, v.fetch || (v.fetch = I, v.Headers = m, v.Request = S, v.Response = A);
            var Q = u(0),
                U = u.n(Q);

            function R(t, a) {
                for (var o = 0; o < a.length; o++) {
                    var d = a[o];
                    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(t, d.key, d)
                }
            }
            var $ = function () {
                function t(e) {
                    (function (r, i) {
                        if (!(r instanceof i)) throw new TypeError("Cannot call a class as a function")
                    })(this, t), this.defaults = Object.assign({}, {
                        cartModalFail: ".js-go-cart-modal-fail",
                        cartModalFailClose: ".js-go-cart-modal-fail-close",
                        cartModal: ".js-go-cart-modal",
                        cartModalClose: ".js-go-cart-modal-close",
                        cartModalContent: ".js-go-cart-modal-content",
                        cartDrawer: ".js-go-cart-drawer",
                        cartDrawerContent: ".js-go-cart-drawer-content",
                        cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
                        cartDrawerFooter: ".js-go-cart-drawer-footer",
                        cartDrawerClose: ".js-go-cart-drawer-close",
                        cartMiniCart: ".js-go-cart-mini-cart",
                        cartMiniCartContent: ".js-go-cart-mini-cart-content",
                        cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
                        cartMiniCartOrgTotal: ".js-go-cart-mini-cart-org-total",
                        cartMiniCartDiscountBlock: ".js-go-cart-mini-cart-discount-block",
                        cartMiniCartDiscount: ".js-go-cart-mini-cart-discount",
                        cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
                        cartMiniCartClose: ".js-go-cart-mini-cart-close",
                        cartMiniCartBlankWrapper: ".js-go-cart-mini-cart-blank",
                        cartTrigger: ".js-go-cart-trigger",
                        cartOverlay: ".js-go-cart-overlay",
                        cartCount: ".js-go-cart-counter",
                        addToCart: ".js-go-cart-add-to-cart",
                        removeFromCart: ".js-go-cart-remove-from-cart",
                        removeFromCartNoDot: "js-go-cart-remove-from-cart",
                        itemQuantity: ".js-go-cart-quantity",
                        itemQuantityPlus: ".js-go-cart-quantity-plus",
                        itemQuantityMinus: ".js-go-cart-quantity-minus",
                        cartMode: "drawer",
                        drawerDirection: "right",
                        displayModal: !1,
                        moneyFormat: "${{amount}}",
                        labelAddedToCart: "was added to your cart.",
                        labelCartIsEmpty: "Your Cart is currently empty!",
                        labelQuantity: "Quantity:",
                        labelRemove: "Remove",
                        hidedElements: []
                    }, e), this.cartModalFail = document.querySelector(this.defaults.cartModalFail), this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose), this.cartModal = document.querySelector(this.defaults.cartModal), this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose), this.cartModalContent = document.querySelector(this.defaults.cartModalContent), this.cartDrawer = document.querySelector(this.defaults.cartDrawer), this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent), this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal), this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter), this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose), this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart), this.cartMiniCartContent = document.querySelectorAll(this.defaults.cartMiniCartContent), this.cartMiniCartSubTotal = document.querySelectorAll(this.defaults.cartMiniCartSubTotal), this.cartMiniCartOrgTotal = document.querySelectorAll(this.defaults.cartMiniCartOrgTotal), this.cartMiniCartDiscount = document.querySelectorAll(this.defaults.cartMiniCartDiscount), this.cartMiniCartDiscountBlock = document.querySelectorAll(this.defaults.cartMiniCartDiscountBlock), this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter), this.cartMiniCartClose = document.querySelectorAll(this.defaults.cartMiniCartClose), this.cartMiniCartBlankWrapper = document.querySelectorAll(this.defaults.cartMiniCartBlankWrapper), this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger), this.cartOverlay = document.querySelector(this.defaults.cartOverlay), this.cartCount = document.querySelectorAll(this.defaults.cartCount), this.addToCart = document.querySelectorAll(this.defaults.addToCart), this.removeFromCart = this.defaults.removeFromCart, this.removeFromCartNoDot = this.defaults.removeFromCartNoDot, this.itemQuantity = this.defaults.itemQuantity, this.itemQuantityPlus = this.defaults.itemQuantityPlus, this.itemQuantityMinus = this.defaults.itemQuantityMinus, this.cartMode = this.defaults.cartMode, this.drawerDirection = this.defaults.drawerDirection, this.displayModal = this.defaults.displayModal, this.moneyFormat = this.defaults.moneyFormat, this.labelAddedToCart = this.defaults.labelAddedToCart, this.labelCartIsEmpty = this.defaults.labelCartIsEmpty, this.labelQuantity = this.defaults.labelQuantity, this.labelRemove = this.defaults.labelRemove, this.hidedElements = this.defaults.hidedElements, this.init()
                }
                var a, o, d;
                return a = t, d = [{
                    key: "removeItemAnimation",
                    value: function (e) {
                        e.classList.add("is-invisible")
                    }
                }], (o = [{
                    key: "init",
                    value: function () {
                        var e = this;
                        this.fetchCart(), this.isDrawerMode && this.setDrawerDirection(), document.addEventListener("click", function (r) {
                            if (r.target.matches(e.defaults.addToCart)) {
                                r.preventDefault();
                                for (var i = r.target.parentNode; i.tagName.toLowerCase() !== "form";) i = i.parentNode;
                                var n = i.getAttribute("id");
                                e.addItemToCart(n)
                            }
                        }, !1), this.cartTrigger.forEach(function (r) {
                            r.addEventListener("click", function () {
                                e.isDrawerMode ? e.openCartDrawer() : e.openMiniCart(), e.openCartOverlay()
                            })
                        }), this.cartOverlay.addEventListener("click", function () {
                            e.closeFailModal(), e.closeCartModal(), e.isDrawerMode ? e.closeCartDrawer() : e.closeMiniCart(), e.closeCartOverlay()
                        }), this.isDrawerMode ? this.cartDrawerClose.addEventListener("click", function () {
                            e.closeCartDrawer(), e.closeCartOverlay()
                        }) : this.cartMiniCartClose.forEach(function (r) {
                            r.addEventListener("click", function () {
                                e.closeMiniCart(), e.closeCartOverlay()
                            })
                        }), this.displayModal && this.cartModalClose.forEach(function (r) {
                            r.addEventListener("click", function () {
                                e.closeFailModal(), e.closeCartModal(), e.isDrawerMode ? e.closeCartDrawer() : e.closeMiniCart(), e.closeCartOverlay()
                            })
                        }), this.cartModalFailClose.addEventListener("click", function () {
                            e.closeFailModal(), e.closeCartModal(), e.isDrawerMode ? e.closeCartDrawer() : e.closeMiniCart(), e.closeCartOverlay()
                        })
                    }
                }, {
                    key: "fetchCart",
                    value: function (e) {
                        var r = this;
                        window.fetch("/cart.js", {
                            credentials: "same-origin",
                            method: "GET"
                        }).then(function (i) {
                            return i.json()
                        }).then(function (i) {
                            return r.fetchHandler(i, e)
                        }).catch(function (i) {
                            throw r.ajaxRequestFail(), new Error(i)
                        })
                    }
                }, {
                    key: "addItemToCart",
                    value: function (e) {
                        var r = this,
                            i = document.querySelector("#".concat(e)),
                            n = U()(i, {
                                hash: !0
                            });
                        window.fetch("/cart/add.js", {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(n)
                        }).then(function (s) {
                            return s.json()
                        }).then(function (s) {
                            return r.addItemToCartHandler(s, n.quantity)
                        }).catch(function (s) {
                            throw r.ajaxRequestFail(), new Error(s)
                        })
                    }
                }, {
                    key: "removeItem",
                    value: function (e) {
                        var r = this,
                            i = new CustomEvent("nutima-cart:remove", {
                                detail: e
                            });
                        document.dispatchEvent(i), window.fetch("/cart/change.js", {
                            method: "POST",
                            credentials: "same-origin",
                            body: JSON.stringify({
                                quantity: 0,
                                line: e
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(function (n) {
                            return n.json()
                        }).then(function () {
                            r.fetchCart()
                        }).catch(function (n) {
                            throw r.ajaxRequestFail(), new Error(n)
                        })
                    }
                }, {
                    key: "changeItemQuantity",
                    value: function (e, r, i) {
                        var n = this;
                        window.fetch("/cart/change.js", {
                            method: "POST",
                            credentials: "same-origin",
                            body: JSON.stringify({
                                quantity: r,
                                line: e
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(function (s) {
                            return s.json()
                        }).then(function (s) {
                            if (n.fetchCart(), s == null ? void 0 : s.items) {
                                var D = new CustomEvent("nutima-cart:change", {
                                    detail: {
                                        type: i,
                                        line: e
                                    }
                                });
                                document.dispatchEvent(D)
                            }
                        }).catch(function (s) {
                            throw n.ajaxRequestFail(), new Error(s)
                        })
                    }
                }, {
                    key: "cartItemCount",
                    value: function (e) {
                        this.cartCount.forEach(function (r) {
                            r.innerHTML = e.item_count
                        })
                    }
                }, {
                    key: "fetchAndOpenCart",
                    value: function () {
                        var e = this;
                        this.fetchCart(function () {
                            e.isDrawerMode ? e.openCartDrawer() : e.openMiniCart(), e.openCartOverlay()
                        })
                    }
                }, {
                    key: "fetchAndOpenModal",
                    value: function (e) {
                        var r = this;
                        this.fetchCart(function () {
                            r.renderCartModal(e), r.openCartModal(), r.openCartOverlay()
                        })
                    }
                }, {
                    key: "fetchHandler",
                    value: function (e, r) {
                        this.cartItemCount(e), window.nutimaCartData = e, this.isDrawerMode ? e.item_count === 0 ? (this.renderBlankCartDrawer(), this.cartDrawerFooter.classList.add("is-invisible")) : (this.renderDrawerCart(e), this.cartDrawerFooter.classList.remove("is-invisible"), this.showElements(), typeof r == "function" && r(e)) : e.item_count === 0 ? (this.renderBlankMiniCart(), this.cartMiniCartFooter.classList.add("is-invisible")) : (this.renderMiniCart(e), this.cartMiniCartFooter.classList.remove("is-invisible"), this.showElements(), typeof r == "function" && r(e))
                    }
                }, {
                    key: "addItemToCartHandler",
                    value: function (e, r) {
                        var i = new CustomEvent("nutima-cart:add", {
                            detail: {
                                product: e,
                                quantity: r
                            }
                        });
                        return document.dispatchEvent(i), this.displayModal ? this.fetchAndOpenModal(e) : this.fetchAndOpenCart()
                    }
                }, {
                    key: "ajaxRequestFail",
                    value: function () {
                        this.openFailModal(), this.openCartOverlay()
                    }
                }, {
                    key: "renderCartModal",
                    value: function (e) {
                        this.clearCartModal();
                        var r = e.variant_title;
                        r = r === null ? "" : "(".concat(r, ")");
                        var i = `
        <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(`.concat(e.image, `);"></div>
            <div class="go-cart-item__info">
                <a href="`).concat(e.url, '" data-handle="').concat(e.handle, '" class="go-cart-item__title">').concat(e.product_title, " ").concat(r, "</a> ").concat(this.labelAddedToCart, `
            </div>
        </div>
      `);
                        this.cartModalContent.innerHTML += i
                    }
                }, {
                    key: "renderDrawerCart",
                    value: function (e) {
                        var r = this;
                        this.clearCartDrawer(), e.items.forEach(function (i, n) {
                            var s = i.variant_title;
                            s === null && (s = "");
                            var D = `
        <div class="go-cart-item__single" data-line="`.concat(Number(n + 1), `">
            <div class="go-cart-item__info-wrapper">
                <div class="go-cart-item__image" style="background-image: url(`).concat(i.image, `);"></div>
                <div class="go-cart-item__info">
                    <a href="`).concat(i.url, '" data-handle="').concat(i.handle, '" class="go-cart-item__title">').concat(i.product_title, `</a>
                    <div class="go-cart-item__variant">`).concat(s, `</div>
                    <div class="go-cart-item__quantity">
                        <span class="go-cart-item__quantity-label">`).concat(r.labelQuantity, ` </span>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="`).concat(i.quantity, `" disabled>
                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                    </div>
                </div>
            </div>
            <div class="go-cart-item__price">`).concat(l(i.line_price, r.moneyFormat), `</div>
            <a class="go-cart-item__remove `).concat(r.removeFromCartNoDot, '">').concat(r.labelRemove, `</a>
        </div>
      `);
                            r.cartDrawerContent.innerHTML += D
                        }), this.cartDrawerSubTotal.innerHTML = l(e.total_price, this.moneyFormat), this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible"), document.querySelectorAll(this.removeFromCart).forEach(function (i) {
                            i.addEventListener("click", function () {
                                t.removeItemAnimation(i.parentNode);
                                var n = i.parentNode.getAttribute("data-line");
                                r.removeItem(n)
                            })
                        }), document.querySelectorAll(this.itemQuantityPlus).forEach(function (i) {
                            i.addEventListener("click", function () {
                                var n = i.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                    s = Number(i.parentNode.querySelector(r.itemQuantity).value) + 1;
                                r.changeItemQuantity(n, s, "increase")
                            })
                        }), document.querySelectorAll(this.itemQuantityMinus).forEach(function (i) {
                            i.addEventListener("click", function () {
                                var n = i.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                    s = Number(i.parentNode.querySelector(r.itemQuantity).value) - 1;
                                r.changeItemQuantity(n, s, "decrease"), Number(i.parentNode.querySelector(r.itemQuantity).value - 1) === 0 && t.removeItemAnimation(i.parentNode.parentNode.parentNode.parentNode)
                            })
                        })
                    }
                }, {
                    key: "renderMiniCart",
                    value: function (e) {
                        var r = this;
                        this.clearMiniCart(), e.items.forEach(function (n, s) {
                            var D = n.variant_title;
                            D === null && (D = "");
                            var F = `
                <div class="go-cart-item__single" data-line="`.concat(Number(s + 1), `">
                    <div class="go-cart-item__info-wrapper">
                        <div class="go-cart-item__image" style="background-image: url(`).concat(n.image, `);"></div>
                        <div class="go-cart-item__info">
                            <a href="`).concat(n.url, '" data-handle="').concat(n.handle, '" class="go-cart-item__title">').concat(n.product_title, `</a>
                            <div class="go-cart-item__variant">`).concat(D, `</div>
                            <div class="go-cart-item__quantity">
                                <span class="go-cart-item__quantity-label">`).concat(r.labelQuantity, ` </span>
                                <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                                <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="`).concat(n.quantity, `" disabled>
                                <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div class="go-cart-item__price">`).concat(n.line_price !== n.original_line_price ? '<span class="go-cart-item__price--original">' + l(n.original_line_price, r.moneyFormat) + "</span>" : "", " ").concat(l(n.line_price, r.moneyFormat), `</div>
                    <a class="go-cart-item__remove `).concat(r.removeFromCartNoDot, '">').concat(r.labelRemove, `</a>
                </div>
            `);
                            r.cartMiniCartContent.forEach(function (z) {
                                z.innerHTML += F
                            })
                        }), this.cartMiniCartSubTotal.forEach(function (n) {
                            n.innerHTML = l(e.total_price, r.moneyFormat), n.parentNode.classList.remove("is-invisible")
                        }), this.cartMiniCartOrgTotal.forEach(function (n) {
                            n.innerHTML = l(e.original_total_price, r.moneyFormat), n.parentNode.classList.remove("is-invisible")
                        }), this.cartMiniCartDiscount.forEach(function (n) {
                            n.innerHTML = l(e.total_discount, r.moneyFormat), n.parentNode.classList.remove("is-invisible"), e.total_discount ? r.cartMiniCartDiscountBlock.forEach(function (s) {
                                s.classList.remove("is-invisible")
                            }) : r.cartMiniCartDiscountBlock.forEach(function (s) {
                                s.classList.add("is-invisible")
                            })
                        }), document.querySelectorAll(this.removeFromCart).forEach(function (n) {
                            n.addEventListener("click", function () {
                                t.removeItemAnimation(n.parentNode);
                                var s = n.parentNode.getAttribute("data-line");
                                r.removeItem(s)
                            })
                        }), document.querySelectorAll(this.itemQuantityPlus).forEach(function (n) {
                            n.addEventListener("click", function () {
                                var s = n.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                    D = Number(n.parentNode.querySelector(r.itemQuantity).value) + 1;
                                r.changeItemQuantity(s, D, "increase")
                            })
                        }), document.querySelectorAll(this.itemQuantityMinus).forEach(function (n) {
                            n.addEventListener("click", function () {
                                var s = n.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                    D = Number(n.parentNode.querySelector(r.itemQuantity).value) - 1;
                                r.changeItemQuantity(s, D, "decrease"), Number(n.parentNode.querySelector(r.itemQuantity).value - 1) === 0 && t.removeItemAnimation(n.parentNode.parentNode.parentNode.parentNode)
                            })
                        }), window.nutimaCartData = e;
                        var i = new Event("nutima-cart:minicart-updated");
                        document.dispatchEvent(i)
                    }
                }, {
                    key: "hideElements",
                    value: function () {
                        this.hidedElements.forEach(function (e) {
                            document.querySelectorAll(e).forEach(function (r) {
                                r.classList.add("is-invisible")
                            })
                        }), this.cartMiniCartBlankWrapper.forEach(function (e) {
                            e.classList.remove("is-invisible")
                        })
                    }
                }, {
                    key: "showElements",
                    value: function () {
                        this.hidedElements.forEach(function (e) {
                            document.querySelectorAll(e).forEach(function (r) {
                                r.classList.remove("is-invisible")
                            })
                        }), this.cartMiniCartBlankWrapper.forEach(function (e) {
                            e.classList.add("is-invisible")
                        })
                    }
                }, {
                    key: "renderBlankCartDrawer",
                    value: function () {
                        this.cartDrawerSubTotal.parentNode.classList.add("is-invisible"), this.clearCartDrawer(), this.cartDrawerContent.innerHTML = '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>"), this.hideElements()
                    }
                }, {
                    key: "renderBlankMiniCart",
                    value: function () {
                        var e = this;
                        this.cartMiniCartSubTotal.forEach(function (r) {
                            r.parentNode.classList.add("is-invisible")
                        }), this.cartMiniCartDiscount.forEach(function (r) {
                            r.parentNode.classList.add("is-invisible")
                        }), this.cartMiniCartOrgTotal.forEach(function (r) {
                            r.parentNode.classList.add("is-invisible")
                        }), this.clearMiniCart(), this.cartMiniCartContent.forEach(function (r) {
                            r.innerHTML = '<div class="go-cart__empty">'.concat(e.labelCartIsEmpty, "</div>")
                        }), this.hideElements()
                    }
                }, {
                    key: "clearCartDrawer",
                    value: function () {
                        this.cartDrawerContent.innerHTML = ""
                    }
                }, {
                    key: "clearMiniCart",
                    value: function () {
                        this.cartMiniCartContent.forEach(function (e) {
                            e.innerHTML = ""
                        })
                    }
                }, {
                    key: "clearCartModal",
                    value: function () {
                        this.cartModalContent.innerHTML = ""
                    }
                }, {
                    key: "openCartDrawer",
                    value: function () {
                        this.cartDrawer.classList.add("is-open")
                    }
                }, {
                    key: "closeCartDrawer",
                    value: function () {
                        this.cartDrawer.classList.remove("is-open")
                    }
                }, {
                    key: "openMiniCart",
                    value: function () {
                        this.cartMiniCart.classList.add("is-open");
                        var e = new Event("nutima-cart:minicart-opened");
                        document.dispatchEvent(e)
                    }
                }, {
                    key: "closeMiniCart",
                    value: function () {
                        this.cartMiniCart.classList.remove("is-open");
                        var e = new Event("nutima-cart:minicart-closed");
                        document.dispatchEvent(e)
                    }
                }, {
                    key: "openFailModal",
                    value: function () {
                        this.cartModalFail.classList.add("is-open")
                    }
                }, {
                    key: "closeFailModal",
                    value: function () {
                        this.cartModalFail.classList.remove("is-open")
                    }
                }, {
                    key: "openCartModal",
                    value: function () {
                        this.cartModal.classList.add("is-open")
                    }
                }, {
                    key: "closeCartModal",
                    value: function () {
                        this.cartModal.classList.remove("is-open")
                    }
                }, {
                    key: "openCartOverlay",
                    value: function () {
                        this.cartOverlay.classList.add("is-open")
                    }
                }, {
                    key: "closeCartOverlay",
                    value: function () {
                        this.cartOverlay.classList.remove("is-open")
                    }
                }, {
                    key: "setDrawerDirection",
                    value: function () {
                        this.cartDrawer.classList.add("go-cart__drawer--".concat(this.drawerDirection))
                    }
                }, {
                    key: "isDrawerMode",
                    get: function () {
                        return this.cartMode === "drawer"
                    }
                }]) && R(a.prototype, o), d && R(a, d), t
            }();
            b.default = $
        }]).default
    })
})(H);
const W = G(H.exports);
new W({
    cartMode: "mini-cart",
    moneyFormat: window.Shopify.money_format || "$ {{amount}}",
    labelQuantity: "",
    labelRemove: "X",
    hidedElements: [".is-blank-hide"]
});

function J() {
    const M = (document.querySelector(".go-cart-mini-cart__shipping") && document.querySelector(".go-cart-mini-cart__shipping").offsetHeight || 0) + (document.querySelector("#shopify-section-announcement") && document.querySelector("#shopify-section-announcement").offsetHeight || 0) + (document.querySelector("#shopify-section-header") && document.querySelector("#shopify-section-header").offsetHeight || 0) + (document.querySelector(".go-cart-mini-cart__bottom") && document.querySelector(".go-cart-mini-cart__bottom").offsetHeight || 0) + 80;
    document.querySelector(".go-cart-mini-cart__content") && document.querySelector(".go-cart-mini-cart__content").setAttribute("style", `max-height:calc(100vh - ${M}px) !important`)
}
document.addEventListener("nutima-cart:minicart-opened", () => {
    J()
});
document.addEventListener("nutima-cart:minicart-updated", () => {
    const M = document.querySelectorAll(".shipping-bar"),
        B = window.nutimaCartData.total_price || 0,
        C = window.themeData.shippingLimit || 0;
    C && M.forEach(b => {
        const u = C - B / 100;
        u > 0 ? (b.querySelector(".shipping-bar__progress").setAttribute("style", `width: ${100-u/C*100}%`), b.querySelector(".shipping-bar__text").innerHTML = themeData.shippingLimitText.replace("{{limit}}", window.Shopify.formatMoney(u * 100, window.Shopify.money_format))) : (b.querySelector(".shipping-bar__progress").setAttribute("style", "width: 100%"), b.querySelector(".shipping-bar__text").innerHTML = themeData.shippingLimitSuccessText)
    })
});
document.body.classList.contains("template-product") && window.addEventListener("scroll", () => {
    var M = document.querySelector(".p-detail__content");
    if (M) {
        var B = M.getBoundingClientRect().top + M.offsetHeight;
        B < 0 ? document.querySelector(".product-sticky-bar").classList.remove("translate-y-full") : document.querySelector(".product-sticky-bar").classList.add("translate-y-full")
    }
});